module.exports = __webpack_public_path__ + "static/share-6d226d569f038d5127c59ef4cb6523ec.png";